<div [ngClass]="{'active': !nestedSubelements && activeCategory}">
  <div class="category-elements" [ngClass]="{'sub-sub-element': subsubElement}">
    <label
      class="category-element global-transition"
      *ngFor="let subelement of finalArray; let i = index"
      [ngClass]="{'category-element-active': checkIfChecked(subelement.id)}">
      <input type="checkbox" (change)="checkboxValue($event, i, subelement)" [checked]="checkIfChecked(subelement.id)" />
      <div class="element-text" [ngClass]="{'subelement-text': nestedSubelements}">
        <div>{{ ( 'categories.' + subelement.id ) | translate }}</div>
        <button
          *ngIf="subelement.children?.length"
          class="btn show-subelements prevent"
          (click)="toggleExpandable(i)"
          [disabled]="hideRuleContent[i] && countCheckedChildren(subelement.children)"
          [ngClass]="{'active-button': hideRuleContent[i]}">
          <nb-icon class="show-more-icon" icon="chevron-right" pack="icomoon" [ngClass]="{ 'chevron-active': hideRuleContent[i] }"> </nb-icon>
        </button>
      </div>
      <span class="checkmark global-transition" [ngClass]="{'checkmark-subelement': nestedSubelements}">
        <!-- <nb-icon icon="check" pack="icomoon"></nb-icon> -->
      </span>
      <div>
        <app-traffic-source-category-subelements
          *ngIf="subelement.children.length && hideRuleContent[i]"
          [defaultValue]="defaultValue"
          [element]="subelement"
          [subsubElement]="true"
          [parentElement]="subelement"
          [checkedValues]="checkedValues"
          [endpointParameterCategory]="endpointParameterCategory"
          (emitCheckedFilters)="getCheckedSubelements($event)"
          [nestedSubelements]="true"></app-traffic-source-category-subelements>
      </div>
    </label>
  </div>
</div>
